import { imagePath } from './imageRegistry';

const angelImg = imagePath('angelDeLaGuarda');
const benedictImg = imagePath('sanctusBenedictus');
const benedictLatinImg = imagePath('latinSanBenito');
const michaelImg = imagePath('galleryStMichael');
// maryCarmen is a Dolorosa (it serves Siete Dolores in reliquiasData); Carmen gets her own image.
const carmenImg = imagePath('carmenStatue');
const carmenImgAlt = imagePath('nun04');
const carmenImgAlt2 = imagePath('nun05');
const carmenCandidates = [carmenImg, carmenImgAlt, carmenImgAlt2].filter(Boolean);
const expeditoImg = imagePath('gallerySanExpedito');
const expeditoImgAlt = imagePath('galleryCruzVsRoma');
const expeditoImgAlt2 = imagePath('stAnthony');
const expeditoCandidates = [expeditoImg, expeditoImgAlt, expeditoImgAlt2].filter(Boolean);
const patrickImg = imagePath('stainedGlass');
const patrickImgAlt = imagePath('earlyChristian');
const patrickCandidates = [patrickImg, patrickImgAlt].filter(Boolean);
const cayetanoImg = imagePath('galleryPastor');
const cayetanoImgAlt = imagePath('stAnthony');
const cayetanoCandidates = [cayetanoImg, cayetanoImgAlt].filter(Boolean);
const salveImg = imagePath('galleryMaterImmaculata');
const salveImgAlt = imagePath('allMary17th');
const salveCandidates = [salveImg, salveImgAlt].filter(Boolean);
const benditoImg = imagePath('misc96PsRGiE');
const benditoImgAlt = imagePath('gallerySagradoCorazon');
const benditoCandidates = [benditoImg, benditoImgAlt].filter(Boolean);

export const OPTIONAL_PRAYERS = [
  {
    id: 'guardian',
    title: 'Ángel de la Guarda',
    img: angelImg,
    imgCandidates: [angelImg].filter(Boolean),
    variants: [
      {
        // Default: the rhymed Spanish form the user prefers.
        id: 'es_dulce',
        label: 'ES rima',
        text:
          'Ángel de mi guarda,\ndulce compañía,\nno me desampares,\nni de noche ni de día.\n\nHasta que me pongas\nen paz y alegría,\ncon todos los santos,\nJesús, José y María.\n\nAmén.',
      },
      {
        id: 'es',
        label: 'ES',
        text:
          'Ángel de Dios, que eres mi guardián, porque el Señor me ha confiado a tu custodia, ilumíname, guárdame, rígeme y gobiérname. Amén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'Angel of God, my guardian dear, to whom God’s love commits me here, ever this day be at my side, to light and guard, to rule and guide. Amen.',
      },
      {
        id: 'la',
        label: 'LA',
        text:
          'Angele Dei, qui custos es mei, me tibi commissum pietate superna; illumina, custodi, rege et guberna. Amen.',
      },
    ],
  },
  {
    id: 'michael',
    title: 'San Miguel Arcángel',
    img: michaelImg,
    imgCandidates: [michaelImg].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'San Miguel Arcángel, defiéndenos en la batalla. Sé nuestro amparo contra la perversidad y las acechanzas del demonio. Reprímale Dios, pedimos suplicantes. Y tú, Príncipe de la milicia celestial, con el poder que Dios te ha conferido, arroja al infierno a Satanás y a los demás espíritus malignos que andan dispersos por el mundo para la perdición de las almas. Amén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'Saint Michael the Archangel, defend us in battle. Be our protection against the wickedness and snares of the devil. May God rebuke him, we humbly pray. And do thou, O Prince of the heavenly host, by the power of God, cast into hell Satan and all the evil spirits who prowl about the world seeking the ruin of souls. Amen.',
      },
      {
        id: 'la',
        label: 'LA',
        text:
          'Sancte Michael Archangele, defende nos in proelio; contra nequitiam et insidias diaboli esto praesidium. Imperet illi Deus, supplices deprecamur: tuque, Princeps militiae caelestis, Satanam aliosque spiritus malignos, qui ad perditionem animarum pervagantur in mundo, divina virtute, in infernum detrude. Amen.',
      },
    ],
  },
  {
    id: 'carmen',
    title: 'Virgen del Carmen',
    img: carmenImg,
    imgCandidates: carmenCandidates.length ? carmenCandidates : [carmenImg].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'Virgen Santísima del Carmen, Madre de Dios y Madre nuestra, míranos con bondad y presérvanos de todo mal. Cúbrenos con tu sagrado manto y condúcenos por los caminos del cielo.\n\nEn tu gloriosa fiesta renovamos la consagración de nuestra familia bajo tu protección maternal. Te ofrecemos la devoción de nuestro corazón y recibimos con amor tu santo Escapulario, señal de tu amor y custodia.\n\nRuega por nosotros, Madre del Carmen, y llévanos a tu Hijo Jesús. Amén.',
      },
      {
        id: 'es_corta',
        label: 'ES breve',
        text:
          'Señora del Carmen: cubrenos con tu manto sagrado, presérvanos del mal y preséntanos al Altísimo como hijos fieles. Amén.',
      },
    ],
  },
  {
    id: 'escapulario',
    title: 'Escápulario del Carmen',
    img: carmenImgAlt,
    imgCandidates: [carmenImgAlt2, carmenImgAlt].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'La Promesa del Escapulario:\n' +
          'Quienquiera que se vista de este Escapulario y muera en penitencia, en fe y en caridad, será preservado del fuego eterno.\n\n' +
          'Nuestra Señora del Monte Carmelo, cúbrenos con tu manto sagrado. Que la gracia de tu amor ' +
          'nos alcance, y que el pasto de los justos no nos desfallezca.\n\n' +
          'Ruega por nosotros, Madre del Monte Carmelo. Amén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'The Promise of the Scapular:\n' +
          'Whoever shall be invested with this Scapular and shall die in penitence, in faith and in charity, shall be preserved from eternal fire.\n\n' +
          'Our Lady of Mount Carmel, cover us with your sacred mantle. May we share in your grace, and may we never fail to reach the pasture of the blessed.\n\n' +
          'Pray for us, Mother of Mount Carmel. Amen.',
      },
      {
        id: 'la',
        label: 'LA',
        text:
          'Promissio Scapularis:\n' +
          'Quicquid hunc Scapulare gestet, et in poenitentia, fide et caritate defunctus fuerit, ab igne aeterno servabitur.\n\n' +
          'Domina Montis Carmeli, sacro tuo velamine nos protege. Ut tua gratia nos attingat, et ad pascua beatorum pervenire mereamur.\n\n' +
          'Ora pro nobis, Mater Montis Carmeli. Amen.',
      },
    ],
  },
  {
    id: 'expedito',
    title: 'San Expedito',
    img: expeditoImg,
    imgCandidates: expeditoCandidates.length ? expeditoCandidates : [expeditoImg].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'Oh glorioso mártir San Expedito, soldado de Cristo, que con tu ejemplo nos enseñas a poner en Dios toda nuestra confianza: intercede por nosotros en esta causa urgente.\n\nConcédenos la gracia de no dejar para mañana lo que podemos hacer hoy, y de vivir cada día con fe y esperanza.\n\nSan Expedito, abogado de las causas justas y urgentes: hoy, no mañana. Amén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'O glorious martyr Saint Expeditus, soldier of Christ, who by your example teach us to place all our trust in God: intercede for us in this urgent need.\n\nGrant us the grace not to put off until tomorrow what we can do today, and to live each day in faith and hope.\n\nSaint Expeditus, advocate of just and urgent causes: today, not tomorrow. Amen.',
      },
      {
        id: 'la',
        label: 'LA',
        text:
          'Gloriose martyr Sancte Expedite, miles Christi, qui exemplo tuo doces nos omnem fiduciam in Deo ponere: intercede pro nobis in hac necessitate urgenti.\n\nConcede nobis gratiam non differendi in cras quod hodie facere possumus, et unumquemque diem in fide et spe vivere.\n\nSancte Expedite, advocatus causarum iustarum et urgentium: hodie, non cras. Amen.',
      },
    ],
  },
  {
    id: 'benedict',
    title: 'San Benito',
    img: benedictImg,
    imgCandidates: [benedictImg, benedictLatinImg].filter(Boolean),
    variants: [
      {
        id: 'la',
        label: 'LA',
        text:
          'Crux sancti patris Benedicti.\nCrux mihi lux!\nNon draco sit mihi dux!\nVade retro Satana!\nNunquam suade mihi vana!\nSunt mala quae libas.\nIpse venena bibas!\nAmen.',
      },
      {
        id: 'es',
        label: 'ES',
        text:
          'La cruz del Santo Padre Benedicto sea mi luz.\n¡No sea el dragón mi guía!\n¡Retírate, Satanás!\n¡Nunca me sugieras vanidades!\nLo que ofreces es malo.\n¡Bebe tú mismo el veneno!\nAmén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'The cross of Holy Father Benedict be my light.\nLet not the dragon be my guide!\nBegone, Satan!\nNever tempt me with vanities!\nWhat you offer is evil.\nDrink the poison yourself!\nAmen.',
      },
    ],
  },
  {
    id: 'patrick',
    title: 'San Patricio — Coraza',
    img: patrickImg,
    imgCandidates: patrickCandidates.length ? patrickCandidates : [patrickImg].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'Me levanto hoy por una fuerza poderosa: la invocación de la Trinidad, la fe en la Trinidad, la confesión de la unidad del Creador.\n\nCristo conmigo, Cristo delante de mí, Cristo detrás de mí,\nCristo en mí, Cristo debajo de mí, Cristo encima de mí,\nCristo a mi derecha, Cristo a mi izquierda,\nCristo cuando me acuesto, Cristo cuando me siento, Cristo cuando me levanto,\nCristo en el corazón de todo el que piensa en mí,\nCristo en la boca de todo el que habla de mí,\nCristo en todo ojo que me mira,\nCristo en todo oído que me escucha.\n\nAmén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'I arise today through a mighty strength: the invocation of the Trinity, belief in the Threeness, confession of the Oneness of the Creator.\n\nChrist with me, Christ before me, Christ behind me,\nChrist in me, Christ beneath me, Christ above me,\nChrist on my right, Christ on my left,\nChrist when I lie down, Christ when I sit down, Christ when I arise,\nChrist in the heart of every man who thinks of me,\nChrist in the mouth of everyone who speaks of me,\nChrist in every eye that sees me,\nChrist in every ear that hears me.\n\nAmen.',
      },
    ],
  },
  {
    id: 'cayetano',
    title: 'San Cayetano',
    img: cayetanoImg,
    imgCandidates: cayetanoCandidates.length ? cayetanoCandidates : [cayetanoImg].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'Glorioso San Cayetano, padre de la Providencia, tú que socorres a los necesitados y das pan a los hambrientos: intercede por nosotros ante el Señor.\n\nConcédeme trabajo digno para ganar el pan de cada día, y la gracia de confiar siempre en la divina Providencia.\n\nSan Cayetano, abogado de los que buscan pan y trabajo, ruega por nosotros. Amén.',
      },
      {
        id: 'es_corta',
        label: 'ES breve',
        text:
          'San Cayetano, padre de la Providencia: dame trabajo digno, pan de cada día y confianza en Dios. Amén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'Glorious Saint Cajetan, father of Providence, who help the needy and give bread to the hungry: intercede for us before the Lord.\n\nGrant me honest work to earn our daily bread, and the grace to trust always in divine Providence.\n\nSaint Cajetan, advocate of those seeking bread and work, pray for us. Amen.',
      },
    ],
  },
  {
    id: 'salve',
    title: 'Salve Regina',
    img: salveImg,
    imgCandidates: salveCandidates.length ? salveCandidates : [salveImg].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'Dios te salve, Reina y Madre de misericordia,\nvida, dulzura y esperanza nuestra:\nDios te salve.\n\nA ti llamamos los desterrados hijos de Eva.\nA ti suspiramos, gimiendo y llorando\nen este valle de lágrimas.\n\nEa, pues, Señora, abogada nuestra,\nvuelve a nosotros esos tus ojos misericordiosos.\n\nY después de este destierro,\nmuéstranos a Jesús, fruto bendito de tu vientre.\n\nOh clemente, oh piadosa, oh dulce siempre Virgen María.\nRuega por nosotros, Santa Madre de Dios,\npara que seamos dignos de alcanzar las promesas\nde Nuestro Señor Jesucristo. Amén.',
      },
      {
        id: 'la',
        label: 'LA',
        text:
          'Salve Regina, Mater misericordiae,\nvita, dulcedo et spes nostra, salve.\n\nAd te clamamus, exsules filii Hevae.\nAd te suspiramus, gementes et flentes\nin hac lacrimarum valle.\n\nEia ergo, Advocata nostra, illos tuos\nmisericordes oculos ad nos converte.\n\nEt Iesum, benedictum fructum ventris tui,\nnobis post hoc exsilium ostende.\n\nO clemens, o pia, o dulcis Virgo Maria.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'Hail, Holy Queen, Mother of Mercy,\nhail, our life, our sweetness and our hope.\nTo thee do we cry, poor banished children of Eve.\nTo thee do we send up our sighs,\nmourning and weeping in this valley of tears.\n\nTurn then, most gracious Advocate,\nthine eyes of mercy toward us.\n\nAnd after this our exile,\nshow unto us the blessed fruit of thy womb, Jesus.\n\nO clement, O loving, O sweet Virgin Mary.\nPray for us, O Holy Mother of God,\nthat we may be made worthy of the promises of Christ. Amen.',
      },
    ],
  },
  {
    id: 'bendito',
    title: 'Bendito sea Dios',
    img: benditoImg,
    imgCandidates: benditoCandidates.length ? benditoCandidates : [benditoImg].filter(Boolean),
    variants: [
      {
        id: 'es',
        label: 'ES',
        text:
          'Bendito sea Dios,\nbendito sea su Santo Nombre,\nbendito sea Jesucristo, verdadero Dios y verdadero hombre,\nbendito sea el nombre de Jesús,\nbendito sea su Sagrado Corazón,\nbendita sea su Preciosísima Sangre,\nbendito sea Jesús en el Santísimo Sacramento del altar,\nbendita sea la Santísima Madre de Dios, María Santísima,\nbendita sea su santa e Inmaculada Concepción,\nbendita sea su gloriosa Asunción,\nbendito sea el nombre de María, Virgen y Madre,\nbendito sea San José, su castísimo esposo,\nbendito sea Dios en sus ángeles y en sus santos.\n\nAmén.',
      },
      {
        id: 'en',
        label: 'EN',
        text:
          'Blessed be God.\nBlessed be His Holy Name.\nBlessed be Jesus Christ, true God and true man.\nBlessed be the name of Jesus.\nBlessed be His Sacred Heart.\nBlessed be His Most Precious Blood.\nBlessed be Jesus in the Most Holy Sacrament of the Altar.\nBlessed be the Holy Mother of God, Mary most holy.\nBlessed be her holy and Immaculate Conception.\nBlessed be her glorious Assumption.\nBlessed be the name of Mary, Virgin and Mother.\nBlessed be Saint Joseph, her most chaste spouse.\nBlessed be God in His angels and in His saints.\n\nAmen.',
      },
    ],
  },
];

export const optionalPrayerThumbnail = (id) => {
  const p = OPTIONAL_PRAYERS.find((x) => x.id === id);
  return p?.img || p?.imgCandidates?.[0] || null;
};
